module.exports = __webpack_public_path__ + "img/browser.2ffdfde.svg";